import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import {
  Box,
  Typography,
  Paper,
  Table,
  TableBody,
  TableRow,
  TableCell,
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(4),
  },
  title: {
    marginBottom: theme.spacing(3),
    textAlign: 'center',
    color: '#EE7203',
  },
  section: {
    marginBottom: theme.spacing(4),
    color: '#2D3741',
  },
  tableContainer: {
    marginTop: theme.spacing(2),
    overflowX: 'auto',
  },
  rowEven: {
    backgroundColor: '#f5b129',
    color: '#2D3741',
  },
  rowOdd: {
    backgroundColor: '#EE7203',
  },
}));

const PrivacyPage = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  const pageTitle = t('common:privacy.pageTitle');
  const sections = t('common:privacy.sections', { returnObjects: true });

  return (
    <Box className={classes.root}>
      <Typography variant="h4" className={classes.title}>
        {pageTitle}
      </Typography>

      {sections.map((section) => (
        <Box key={section.key} className={classes.section}>
          <Typography variant="h5" gutterBottom style={{ color: '#2D3741' }}>
            {section.title}
          </Typography>

          {section.table ? (
            <Paper elevation={1} className={classes.tableContainer}>
              <Table>
                <TableBody>
                  {section.table.map((row, rowIndex) => (
                    <TableRow
                      key={rowIndex}
                      className={
                        rowIndex % 2 === 0 ? classes.rowEven : classes.rowOdd
                      }
                    >
                      {row.map((cell, cellIndex) => (
                        <TableCell key={cellIndex}>{cell}</TableCell>
                      ))}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Paper>
          ) : (
            section.description.map((para, paraIndex) => (
              <Typography
                key={paraIndex}
                variant="body1"
                paragraph
                style={{ color: '#2D3741' }}
              >
                {para}
              </Typography>
            ))
          )}
        </Box>
      ))}
    </Box>
  );
};

export default PrivacyPage;
